import { createRequestActions } from 'actions';

export const allNews = createRequestActions({
  type: 'ALL_NEWS',
  url: '/buildings/news/all?type=all'
});

export const nedvexNews = createRequestActions({
  type: 'NEDVEX_NEWS',
  url: '/buildings/news/all?type=nedvex'
});

export const favoritesNews = createRequestActions({
  type: 'FAVORITES_NEWS',
  url: '/buildings/news/all?type=favorites'
});



// WEBPACK FOOTER //
// ./src/actions/news.js